import angular from 'angular';
import uiRouter from 'angular-ui-router';

import categoriesComponent from './categories.component';
import categoryForm from './category-form/category-form.module';

export default
  angular.module('components.app.admin.categories', [
    uiRouter,
    categoryForm
  ])
    .component('categories', categoriesComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('categories', {
          parent: 'admin',
          url: '/categories',
          component: 'categories',
          resolve: {
            flex: () => '100',
            layout: () => 'column'
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/categories/categories.module.js